import {
  FETCH_SUGGESTIONS_REQUEST,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_FAILURE
} from "../store/actionTypes";

interface Suggestion {
  id: number;
  text: string;
}

interface SuggestionsState {
  suggestions: Suggestion[];
  isLoading: boolean;
  error: string | null;
}

interface Action {
  type: string;
  payload?: any;
}

const initialState: SuggestionsState = {
  suggestions: [],
  isLoading: false,
  error: null,
};

const suggestionsReducer = (state = initialState, action: Action): SuggestionsState => {
  switch (action.type) {
    case FETCH_SUGGESTIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_SUGGESTIONS_SUCCESS:
      return { ...state, isLoading: false, suggestions: action.payload };
    case FETCH_SUGGESTIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default suggestionsReducer;
